export default {
  name: 'misc.situation',
  key: 'situation',
  attributes: {
    things: {
      key: 'things',
      name: 'entity.gasGiantMine.situation.things',
    },
    supplies: {
      key: 'supplies',
      name: 'entity.gasGiantMine.situation.supplies',
    },
    revolt: {
      key: 'revolt',
      name: 'entity.gasGiantMine.situation.revolt',
    },
    pirates: {
      key: 'pirates',
      name: 'entity.gasGiantMine.situation.pirates',
    },
    remnants: {
      key: 'remnants',
      name: 'entity.gasGiantMine.situation.remnants',
    },
  },
};
